import { Extension, ReaderContext, WriterContext } from '@gltf-transform/core3';
import { CYNCLY_ITEMS_METADATA } from '../constants';
import { ItemMetadata } from './item-metadata';

const NAME = CYNCLY_ITEMS_METADATA;

export type IClassificationMetadata = Pick<IClassification, "baseItemType" | "characteristics" | "tags">;
export type AnyGeometryType = GeometryType | SubGeometryType;

interface ItemMetadataDef {
	classification: IClassificationMetadata | null;
	geometryType: AnyGeometryType | null;
	instanceId: string | null;
	itemId: string | null;
	subItemScope: string | null;
	visible: boolean | null;
}

export class CYNCLYItemsMetadata extends Extension {
	public readonly extensionName = NAME;
	public static readonly EXTENSION_NAME = NAME;

	/** Creates a new ItemMetadata property for use on a {@link Node}. */
	public createItemMetadata(name = ''): ItemMetadata {
		return new ItemMetadata(this.document.getGraph(), name);
	}

	public read(context: ReaderContext): this {
		const jsonDoc = context.jsonDoc;

		jsonDoc.json.nodes!.forEach((nodeDef, nodeIndex) => {
			if (!nodeDef.extensions || !nodeDef.extensions[NAME]) return;
			const itemMetadataDef = nodeDef.extensions[NAME] as ItemMetadataDef;
			const itemMetadata = this.createItemMetadata()
			itemMetadata.setGeometryType(itemMetadataDef.geometryType);
			itemMetadata.setInstanceId(itemMetadataDef.instanceId);
			itemMetadata.setItemId(itemMetadataDef.itemId);
			itemMetadata.setSubItemScope(itemMetadataDef.subItemScope);
			itemMetadata.setVisible(itemMetadataDef.visible);
			itemMetadata.setClassification(itemMetadataDef.classification);

			context.nodes[nodeIndex].setExtension(NAME, itemMetadata);
		});

		return this;
	}

	public write(context: WriterContext): this {
		if (this.properties.size === 0) return this;

		this.document
			.getRoot()
			.listNodes()
			.forEach((node) => {
				const itemMetadata = node.getExtension<ItemMetadata>(NAME);
				if (itemMetadata) {
					const itemMetadataDef = {} as ItemMetadataDef;

					if (itemMetadata.getGeometryType() != null)
						itemMetadataDef.geometryType = itemMetadata.getGeometryType();
					if (itemMetadata.getInstanceId() != null)
						itemMetadataDef.instanceId = itemMetadata.getInstanceId();
					if (itemMetadata.getItemId() != null)
						itemMetadataDef.itemId = itemMetadata.getItemId();
					if (itemMetadata.getSubItemScope() != null)
						itemMetadataDef.subItemScope = itemMetadata.getSubItemScope();
					if (itemMetadata.isVisible() != null)
						itemMetadataDef.visible = itemMetadata.isVisible();
					if (itemMetadata.getClassification() != null) {
						const classification = itemMetadata.getClassification()!;
						itemMetadataDef.classification = classification
					}

					const nodeIndex = context.nodeIndexMap.get(node)!;
					const nodeDef = context.jsonDoc.json.nodes![nodeIndex];
					nodeDef.extensions = nodeDef.extensions || {};
					nodeDef.extensions[NAME] = itemMetadataDef;
				}
			});

		return this;
	}
}
